import apiClient from "../helpers/apiClient";
import { handleApiError } from "../utils/handleApiError";
import store from "../../setup/redux/Store";

const Logout = () => {
    window.location.href = '/';
}

export async function getTasks(params:any = {}) {
    try {
        const response = await apiClient.get(`/admins/tasks/`, { params });
        return response.data;
    } catch (error) {
        handleApiError(error, {
            onUnauthorized: Logout,
            onServerError: Logout,
        });
    }
}

export async function getTasksById(taskId:number) {
    const response = await apiClient.get(`/admins/tasks/${taskId}/`);
    return response.data;
}

export async function createTask(task:any) {
    const response = await apiClient.post(`/admins/tasks/`,{...task});
    return response;
}

export async function deleteTask(taskId:number) {
    const response = await apiClient.delete(`/admins/tasks/${taskId}/`);
    return response;
}

export async function updateTask(idTicket:number,ticket:any) {
    const response = await apiClient.patch(`/admins/tasks/${idTicket}/`,{...ticket});
    return response;
}

export async function getTasksSummary() {
    try {
        const token = store.getState().auth?.accessToken;
        const response = await apiClient.get(`/admins/dashboard/global-summary/`, {headers: {
                Authorization: `Bearer ${token}`
            }});
        return response.data;
    } catch (error) {
        handleApiError(error, {
            onUnauthorized: Logout,
            onServerError: Logout,
        });
    }
}